export default "__VITE_ASSET__CslxSt0I__"